import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/ZepColorPrimary.tsx
const ZepColorPrimaryIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.29 10.006c.397-1.66.257-3.218-.518-4.453-1.033-1.641-3-2.39-5.337-2.27-1.762-1.839-3.9-2.692-5.921-2.094-1.656.488-2.96 1.865-3.787 3.762-1.973.73-3.441 2.043-3.995 3.813-.462 1.482-.217 3.067.58 4.56-.644 1.939-.595 3.793.3 5.214 1.129 1.793 3.369 2.519 5.99 2.215 1.754 1.814 3.875 2.651 5.884 2.058 1.655-.488 2.96-1.865 3.786-3.762 1.973-.73 3.442-2.043 3.995-3.813.534-1.706.127-3.549-.98-5.23h.003Zm-6.63 6.682H9.29a1.397 1.397 0 0 1-1.278-.86 1.473 1.473 0 0 1 .248-1.55l3.229-3.626h-2.2c-.77 0-1.395-.644-1.395-1.437s.624-1.437 1.395-1.437h5.37c.554 0 1.054.338 1.278.86.222.522.124 1.13-.249 1.55l-3.228 3.627h2.2c.77 0 1.395.644 1.395 1.437 0 .792-.624 1.436-1.396 1.436Z",
		fill: "#6758FF"
	})
}));
//#endregion
export { ZepColorPrimaryIcon };
